import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  // imgLink = [
  //   'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2F4.Big-Ass.jpg?alt=media&token=2f634a5b-8590-4946-85a4-4e06ee99b9e4',
  //   'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2FWebp.net-resizeimage%20(4).jpg?alt=media&token=8ba3338a-dc8e-4c9a-89f2-20bd19a6afda',
  //   'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2FWebp.net-resizeimage%20(5).jpg?alt=media&token=1cb40823-a58c-4cb8-a078-ce363772ca7b',
  //   'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2FWebp.net-resizeimage%20(6).jpg?alt=media&token=aba3c2c2-1fdd-4424-aa7f-77b57ca1fa68'
  //   // 'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2F1539829850182finisher.jpg?alt=media&token=5acae306-92fb-4da6-89bf-8bbad297c358',
  //   // 'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2F15398298348055km.jpg?alt=media&token=9b52d62f-f3b6-4f59-ae44-10eecdbf2246'
  // ];

  imgsTitles = [
    {
      name: '',
      name_en: '',
      imgLink:
        'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2F1537857248264IMG_1394.JPG?alt=media&token=470d10cb-e7ce-4124-857a-cac239ce3a6d',
      imgLink_en:
        'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2F1537857248264IMG_1394.JPG?alt=media&token=470d10cb-e7ce-4124-857a-cac239ce3a6d',
      partLink: '/rock-charity-live-in-phuket'
    },
    {
      name: 'จำหน่ายเสื้อรายการ วิ่ง สนุก อนุรักษ์เต่าทะเล ครั้งที่ 14',
      name_en: 'The 14th Turtle Fun Run Shop',
      imgLink:
        'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2FWebp.net-resizeimage%20(8).jpg?alt=media&token=5539ac38-ad60-4672-8235-d2c71feb3479',
      imgLink_en:
        'https://firebasestorage.googleapis.com/v0/b/psg-events.appspot.com/o/imgs%2Fevents%2FWebp.net-resizeimage%20(8).jpg?alt=media&token=5539ac38-ad60-4672-8235-d2c71feb3479',
      partLink: '/turtle-fun-run-14-shirt'
    }
  ];

  // 1982 × 826

  lg;
  constructor(private translateService: TranslateService) {
    translateService.setDefaultLang('en');
    translateService.use('th');
    this.lg = 'th';
  }

  ngOnInit() {}

  ChangeLanguage(language: string) {
    this.translateService.use(language);
    this.lg = language;
  }

  scroll(id) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }
}
